import BundlePageSectionProps from '@src/quince-site-pdp/src/domains/BundlePageSectionProps'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import BundleProductPurchaseDS from './bundle-product-purchase-ds'
import BundleProductPurchaseLegacy from './bundle-product-purchase-legacy'

const BundleProductPurchase = (props: BundlePageSectionProps) => {
  if (shouldUseDesignSystem()) {
    return <BundleProductPurchaseDS {...props} />
  }
  return <BundleProductPurchaseLegacy {...props} />
}

export default BundleProductPurchase
